import { useLayoutEffect, useState, useCallback } from 'react';
import { useReactiveVar } from '@apollo/client';
import { selectedSectionsVar } from '../../../gqlCommon/graphql/cache';

export const useExpandSections = (translationId: string) => {
  const [currentSection, setCurrentSection] = useState(true);
  const selectedSections = useReactiveVar(selectedSectionsVar);

  const setExpandedSection = useCallback(
    (nextValue: boolean) => {
      const selectedSection = {
        value: nextValue,
        id: translationId,
      };
      const checkSection = [...selectedSections, selectedSection];
      const availableKeys = selectedSections.map(value => value.id);
      const includesIds = availableKeys.includes(translationId);
      const setSelectedSection = selectedSections.map(section => {
        return section.id === translationId ? selectedSection : section;
      });

      selectedSectionsVar(!includesIds ? checkSection : setSelectedSection);
    },
    [selectedSections, translationId],
  );

  useLayoutEffect(() => {
    const section = selectedSections.find(section => section.id === translationId);
    setCurrentSection(section ? section.value : true);
  }, [selectedSections, translationId]);

  return { setExpandedSection, currentSection };
};
